import {
  compose, not, either, isNil, isEmpty,
} from 'ramda';
import { V_TYPE_INTEGER, V_TYPE_NUMBER } from 'app-constants/variableTypes';

export const isNotEmpty = compose(not, either(
  isNil,
  isEmpty,
));

export const stateReducer = (prevState, newState) => ({ ...prevState, ...newState });

export const patternSelector = (type = '') => {
  switch (type) {
    case V_TYPE_INTEGER:
      return /^\d+$/;
    case V_TYPE_NUMBER:
      return /^[+-]?\d+(\.\d+)?$/;
    default:
      return null;
  }
};

export const checkValidations = (value, rules) => {
  let valid = true;
  if (rules.required) {
    valid = value !== undefined && value !== null && String(value).trim() !== '' && valid;
  }
  if (rules.pattern) {
    valid = rules.pattern.test(value) && valid;
  }
  if (rules.notIncluded) {
    valid = !rules.notIncluded.includes(value) && valid;
  }
  if (rules.minLength) {
    valid = (rules.minLength <= value.length) && valid;
  }
  if (rules.arrayObject) {
    const { keys, validation: arrayValidation } = rules.arrayObject;
    if (keys) {
      value.forEach((item) => {
        keys.forEach((key) => {
          valid = checkValidations(item[key], arrayValidation) && valid;
        });
      });
    }
  }

  return valid;
};

// Campo de formulario { value, validation, valid, touched } con un valor nuevo,
// marcado como tocado y revalidado. No modifica el campo anterior.
export const changeField = (current, value) => ({
  ...current,
  value,
  valid: checkValidations(value, current.validation),
  touched: true,
});

// Igual que changeField, pero conserva `valid` (lo valida quien edita el valor).
export const touchField = (current, value) => ({ ...current, value, touched: true });

/**
 * Deprecated, use `validateForm` instead.
 * This method returns `undefined` instead of false if the `valid` property is not present for
 * a form key, and an undefined return may mess up with a component's default props (it may
 * interpret the undefined as true depending on the configuration of the default props).
 */
export const getFormValidity = (formState) => {
  let formValidity = true;
  Object.keys(formState).forEach((inputKey) => {
    formValidity = formState[inputKey].valid && formValidity;
  });
  return formValidity;
};

// Los formularios guardan a veces datos que no son campos (p. ej. `schema` u
// `outputs` de la función elegida, que pueden ser undefined): solo cuentan las
// claves con `valid` / `touched`.
export const validateForm = (formState) => Object.keys(formState)
  .reduce((isValid, inputKey) => {
    if (formState[inputKey]?.valid !== undefined) {
      return !!formState[inputKey].valid && isValid;
    }
    return isValid;
  }, true);

export const getFormTouched = (formState) => Object.keys(formState)
  .some((inputKey) => formState[inputKey]?.touched === true);

export const setFormUntouched = (formState, setState) => {
  Object.keys(formState).forEach((inputKey) => {
    const newInput = {
      ...formState[inputKey],
    };
    newInput.touched = false;
    setState({
      [inputKey]: newInput,
    });
  });
};
